/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const updateUserPathParamsSchema = z.object({
    "id": z.string().describe("Sidekick user id")
    })

/**
 * @description User updated
 */
export const updateUser200Schema = z.object({
    "id": z.string(),
"email": z.string(),
"name": z.string(),
"active": z.boolean(),
"monitoringEnabled": z.boolean(),
"maxContactsAllowed": z.int().min(-9007199254740991).max(9007199254740991),
"createdAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const updateUser400Schema = z.any()

/**
 * @description User not found
 */
export const updateUser404Schema = z.any()

export const updateUserMutationRequestSchema = z.object({
    "email": z.optional(z.string().min(1)),
"name": z.optional(z.string().min(1)),
"active": z.optional(z.boolean()),
"monitoringEnabled": z.optional(z.boolean()),
"maxContactsAllowed": z.optional(z.int().min(0).max(9007199254740991))
    })

export const updateUserMutationResponseSchema = z.lazy(() => updateUser200Schema)